import React from "react";
import BlogFour from "../component/BlogFour";

function BlogFourContainer() {
  return <BlogFour />;
}
export default BlogFourContainer;
